module.exports = __webpack_public_path__ + "img/LogoLG.c5713277.png";